var _rect, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForeheadBgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 373,
    viewBox: "0 0 1440 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_383_2356",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 373
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1439,
    height: 372,
    fill: "#D9D9D9",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_383_2356)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.793,
    cy: 251.561,
    rx: 42.063,
    ry: 40.7742,
    transform: "rotate(-2.48788 121.793 251.561)",
    fill: "#FFF9E6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1163.1,
    cy: 181.905,
    rx: 172.816,
    ry: 174.261,
    transform: "rotate(-2.48788 1163.1 181.905)",
    fill: "#FFF9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.03 8.48318L110.637 212.242L114.085 291.609L1154.66 345.208L1140.03 8.48318Z",
    fill: "#FFF9E6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_2356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.16 372.453L150.619 263.004L134.86 234.227L131.16 211.068L167.356 199.019L170.918 153H181.354V201.443L190.505 231.585L178.505 263.004L177.872 372.453H131.16Z",
    fill: "#FFE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9277 372.626L47.3349 279.4L42.2007 254.995L82.8882 216.88L103.286 228.869L96.1638 231.442H81.6022L68.3266 254.995L87.7948 274.691H96.1638V281.121L71.3141 286.691L73.6982 372.626H25.9277Z",
    fill: "#FFE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7949 233.578V274.691L168.438 269.982L164.689 223.726L87.7949 233.578Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.764 231.758V215.702H130.094L138.572 229.561L111.764 231.758Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.169 267.727C136.506 267.727 145.696 260.268 145.696 251.068C145.696 241.868 136.506 234.409 125.169 234.409C113.833 234.409 104.643 241.868 104.643 251.068C104.643 260.268 113.833 267.727 125.169 267.727Z",
    fill: "#D9E0A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.169 265.155C132.949 265.155 139.256 258.848 139.256 251.068C139.256 243.288 132.949 236.981 125.169 236.981C117.389 236.981 111.082 243.288 111.082 251.068C111.082 258.848 117.389 265.155 125.169 265.155Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.168 261.128C130.724 261.128 135.229 256.624 135.229 251.067C135.229 245.511 130.724 241.007 125.168 241.007C119.612 241.007 115.107 245.511 115.107 251.067C115.107 256.624 119.612 261.128 125.168 261.128Z",
    fill: "#D9E0A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.107 220.817L116.235 228.661H130.728L128.838 219.046L115.107 220.817Z",
    fill: "#D9E0A2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204 296L1139 355L1111 259L1059 224H656L204 296Z",
    fill: "#FFF9E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_2356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 244.58,
    height: 219.453,
    fill: "white",
    transform: "translate(-53 153)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeheadBgLeft);
export default __webpack_public_path__ + "static/media/forehead-bg-left.025997c32e0f53b9904f2e58b091415b.svg";
export { ForwardRef as ReactComponent };